import React from "react"
import Image from "next/image"
import { ColorSwatch as SwatchType } from "@/app/(site)/contexts/Global/types"

const CLIP_PATH_TOP_HALF = "polygon(0 0, 100% 0, 50% 100%, 0 100%)"
const CLIP_PATH_BOTTOM_HALF = "polygon(50% 0, 100% 0, 100% 100%, 50% 100%)"

interface SwatchImageProps {
    swatch: SwatchType
}

const SwatchImage: React.FC<SwatchImageProps> = ({ swatch }) => {
    const { lens, hex, isAvailable, image, color_name } = swatch
    const isSwatchImageAvailable = Array.isArray(image?.url) && image?.url.length > 0
    const swatchLensHex = lens?.hex
    const whiteColor = "#ffffff"

    return (
        <>
            {lens && (
                <div className="absolute h-40 w-40 rotate-[-50deg]">
                    <div className="relative h-40 w-40">
                        {isSwatchImageAvailable ? (
                            <Image
                                alt={color_name}
                                src={image.url}
                                width={100}
                                height={100}
                                className="absolute inset-0 rounded-full"
                                style={{
                                    clipPath: CLIP_PATH_TOP_HALF,
                                    backgroundColor: swatchLensHex
                                }}
                            />
                        ) : (
                            <div
                                className="absolute inset-0 rounded-full"
                                style={{
                                    clipPath: CLIP_PATH_TOP_HALF,
                                    backgroundColor: swatchLensHex ?? hex
                                }}
                                aria-hidden="true"
                            ></div>
                        )}
                        <div
                            className="absolute inset-0 rounded-full"
                            style={{
                                clipPath: CLIP_PATH_BOTTOM_HALF,
                                backgroundColor: hex
                            }}
                        ></div>
                    </div>
                </div>
            )}
            {isAvailable ? (
                <div
                    style={{ backgroundColor: hex }}
                    className="h-30 w-30 rounded-full p-1 md:h-40 md:w-40"
                />
            ) : (
                <div className="relative h-30 w-30 rotate-[-50deg] rounded-full md:h-40 md:w-40">
                    {isSwatchImageAvailable ? (
                        <Image
                            alt={color_name}
                            src={image.url}
                            width={100}
                            height={100}
                            className="absolute inset-0 rounded-full"
                            style={{
                                clipPath: CLIP_PATH_TOP_HALF,
                                backgroundColor: swatchLensHex
                            }}
                        />
                    ) : (
                        <div
                            className="absolute inset-0 rounded-full"
                            style={{
                                clipPath: CLIP_PATH_TOP_HALF,
                                backgroundColor: swatchLensHex ?? hex
                            }}
                        ></div>
                    )}
                    <div
                        className="absolute inset-0 rounded-full"
                        style={{
                            clipPath: CLIP_PATH_BOTTOM_HALF,
                            backgroundColor: hex
                        }}
                    ></div>
                    <div className="absolute inset-0 flex items-center justify-center rounded-full bg-white bg-opacity-40">
                        {hex === whiteColor ? (
                            <div className="absolute h-30 w-4 rotate-[95deg] bg-black md:h-42" />
                        ) : (
                            <div className="absolute h-30 w-2 rotate-[95deg] bg-main-medium-grey md:h-42" />
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default SwatchImage
